import { render, staticRenderFns } from "./SurveysDashboardCard.vue?vue&type=template&id=108ea903"
import script from "./SurveysDashboardCard.vue?vue&type=script&lang=js"
export * from "./SurveysDashboardCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports